import ReactJson from "react-json-view";
import { useTheme } from "@mui/material/styles";

import { cmpBaseColors } from "../../../../cmpBaseColors";
import { ThemeModes } from "../../../../muiThemeTypes";

export const CloudFlowJsonFormatter = ({ jsonObj }: { jsonObj: object }) => {
  const theme = useTheme();

  return (
    <ReactJson
      src={jsonObj}
      name={null}
      theme={theme.palette.mode === ThemeModes.DARK ? "google" : "summerfruit:inverted"}
      iconStyle="triangle"
      enableClipboard={true}
      displayDataTypes={false}
      displayObjectSize={false}
      indentWidth={2}
      collapsed={false}
      collapseStringsAfterLength={false}
      style={{
        border: "1px solid",
        borderColor: theme.palette.divider,
        overflowX: "scroll",
        backgroundColor:
          theme.palette.mode === ThemeModes.DARK ? cmpBaseColors.backgroundDark : cmpBaseColors.lightBackground,
        fontSize: "14px",
      }}
    />
  );
};
